import { render } from "./addLinkedAccountModal.vue?vue&type=template&id=dcf49bf2&ts=true"
import script from "./addLinkedAccountModal.vue?vue&type=script&lang=ts"
export * from "./addLinkedAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__